<template>
    <div
        class="forgot-pw-ep-page locale-font"
        :style="{'background-image': `url(${require('@/assets/login-bg.jpg')})`}">
        <div class="top-left-logo">
            <img src="@/assets/logo-trans.png" />
        </div>
        <div class="top-right-lang">
            <ChangeLang />
        </div>
        <v-card
            width="570"
            outlined>
            <div v-if="state === 'input-email'">
                <v-card-text class="card-input">
                    <div class="header-forgot-pw-ep">
                        {{ $vuetify.lang.t('$vuetify.resetPasswordExpired.resetPasswordExpired') }}
                    </div>
                    <div class="sub-header-forgot-pw-ep">
                        {{ $vuetify.lang.t('$vuetify.resetPasswordExpired.textPasswordExpired') }}
                    </div>
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                        v-on:submit.prevent>
                        <v-text-field
                            :label="this.$vuetify.lang.t('$vuetify.resetPasswordExpired.emailAddress')"
                            v-model="form.email"
                            type="text"
                            :placeholder="this.$vuetify.lang.t('$vuetify.resetPasswordExpired.enterYourEmailAddress')"
                            v-on:keyup.enter="onSubmit()"
                            :rules="emailRules"
                        ></v-text-field>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-row>
                        <v-col cols="12 flex-center">
                            <v-btn
                                class="mx-auto my-5"
                                width="264"
                                color="primary"
                                @click="onSubmit()">
                                {{ $vuetify.lang.t('$vuetify.resetPasswordExpired.sendEmail') }}
                            </v-btn>
                        </v-col>
                        <v-col cols="12 flex-center pt-0">
                            <span
                                class="back-to-login"
                                @click="goToLoginPage()">
                                {{ $vuetify.lang.t('$vuetify.resetPasswordExpired.returnToLogIn') }}
                            </span>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </div>
            <div v-else-if="state === 'sent-email'">
                <v-card-text class="card-input">
                    <div class="header-forgot-pw-ep">
                        <i class="icon-header fas fa-check-circle mr-3"></i>
                        {{ $vuetify.lang.t('$vuetify.resetPasswordExpired.emailSent') }}
                    </div>
                    <div class="sub-header-forgot-pw-ep">
                        {{ $vuetify.lang.t('$vuetify.resetPasswordExpired.resetPasswordLink') }}

                        <br>

                        <span class="sent-email">
                            {{ form.email }}
                        </span>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-btn
                        class="mx-auto my-5"
                        width="264"
                        color="primary"
                        @click="notThisEmail()">
                        {{ $vuetify.lang.t('$vuetify.resetPasswordExpired.notThisEmail') }}
                    </v-btn>
                </v-card-actions>
            </div>
        </v-card>
    </div>
</template>
<script>
import ChangeLang from '@/components/ChangeLang'

export default {
    name: 'ResetPasswordExpired',

    components: {
        ChangeLang
    },

    data () {
        return {
            valid: true,
            form: {
                email: ''
            },
            loading: false,
            emailRules: [
                v => !!v || this.$vuetify.lang.t('$vuetify.resetPasswordExpired.emailAddressIsRequired'),
                v => (/\S+@\S+\.\S+/).test(v) || this.$vuetify.lang.t('$vuetify.resetPasswordExpired.emailAddressIsNotValid')
            ],
            state: 'input-email' // two possible states, input-email and sent-email
        }
    },

    methods: {
        async onSubmit () {
            if (!this.$refs.form.validate()) {
                return
            }

            this.$store.dispatch('setLoading', true)

            const res = await this.axios.post('user/forget-password', this.form)

            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
            }
        },

        goToLoginPage () {
            this.$router.push({ name: 'Login' }, () => {})
        },

        notThisEmail () {
            this.form.email = ''
            this.state = 'input-email'
        }
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.$utils.recheckValidate(this.$refs.form.inputs)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.forgot-pw-ep-page {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;

    .v-content {
        height: 100%;
    }
}
.header-forgot-pw-ep {
    margin-top: 2rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
    font-size: 24px;
    font-weight: 500;
}
.sub-header-forgot-pw-ep {
    margin-bottom: 1rem;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
}
.card-input {
    padding: 0rem 5rem;
}
.back-to-login {
    margin-bottom: 1.5rem;
    cursor: pointer;
    color: #D76436;
    font-weight: 500;
}
.flex-center {
    display: flex;
    justify-content: center;
}
.sent-email {
    color: #D76436;
}
.icon-header {
    color: #139888;
}
</style>
